import "./UsageByDays.scss";

import type { FC } from "react";
import { memo, useMemo } from "react";

import { BarChart } from "../../../../components/charts/BarChart";
import { StackedChart } from "../../../../components/charts/StackedChart";
import type { IChartThemeMode } from "../../../../components/charts/types";
import { useCharts } from "../../../../components/charts/useCharts";
import { useThemeMode } from "../../../../contexts/theme-mode/ThemeModeProvider";
import type { IUsageAnalytics } from "../../../../hooks/reactQueryHooks/useUsage";

interface IProps {
  tokens?: IUsageAnalytics["tokens"];
  prices?: IUsageAnalytics["prices"];
}

const UsageByDays: FC<IProps> = memo(props => {
  const { mode } = useThemeMode();

  const { tokensUsageChartData, costAndSavingsChartData } = useCharts({
    analyticData: props,
  });

  return (
    <div className="usage-charts-container">
      <h4 className="billing-table-title">Breakdown by days:</h4>
      <div>
        <BarChart
          chartData={costAndSavingsChartData}
          themeMode={mode as IChartThemeMode}
          height={230}
        />
        <StackedChart
          chartData={tokensUsageChartData}
          themeMode={mode as IChartThemeMode}
          height={230}
        />
      </div>
    </div>
  );
});

export { UsageByDays };
